(function ($) {
  $(window).on('load', function () {
    setTimeout(function () {
      $('.view-remove-quotes').each(function () {
        var value = $(this).text();
        $(this).empty();
        $(this).append(value);
      });
    }, 300);
  })
})(jQuery);